import { ClientConfig } from "../components/util/types/ClientConfig";

export const realeriskConfig: ClientConfig = {
  agriCompanyCodesMap: [
    { name: "RMA", value: "035" },
    { name: "ITA", value: "023" },
  ],
  companyCodesMap: [
    { name: "RMA", value: "001" },
    { name: "ITA", value: "003" },
  ],
  domainName: "realeRisk.com",
  defaultAddress: "Reale Mutua Assicurazioni, Via Corte d'Appello 11, Turin, Turin 10122, Italy",
  defaultLocation: [7.679044, 45.0742872],
  emergencyGeoJsonSubdirectory: "terrasheld",
  geocoderSearchItalyOnly: true,
  greenPlaneCenter: [14.369258, 37.57785],
  label: "Realerisk",
  name: "realerisk",
  natCatEuroExplanationText: "Euro",
  natCatGeoJsonSubDirectory: "natcat_reale",
  natCatPolicySelectionText: "Only locations from RMA and ITA valid on 11/11/2025 are considered",
  redPlaneCenter: [7.679044, 45.0742872],
  showHelpCenter: true,
  showNatCatAnalyticsFilter: true,
  tableColumns: {
    coinsuranceType: true,
    commercialProduct: true,
    sire: true,
  },
};
